import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import VerticalTabs from 'components/Tab/VerticalTabs';
// import DeliveryStaffOrderTable from 'components/DeliveryStaffOrderTable';
import OrderTable from 'components/OrderTable';
import RecurringOrderTable from 'components/RecurringOrderTable';
import DeliveryStaffDocumentTable from 'components/DeliveryStaffDocumentTable';
// import NotificationTable from 'components/NotificationTable';
// import DeliveryStaffTransactionTable from 'components/DeliveryStaffTransactionTable';
// import DeliveryStaffStatementTable from 'components/DeliveryStaffStatementTable';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import DeliveryStaffContract from 'components/DeliveryStaffContract';
import DeliveryDiary from 'views/Admin/DeliveryDiary/DeliveryDiary';
import Schedule from 'views/Admin/Schedule/Schedule';
import DeliveryStaffCard from 'components/Card/DeliveryStaffCard';

const useStyles = makeStyles((theme) => ({
  collapsibleGrid: {
    'width': 'auto',
    'transition': 'width 0.3s ease-in-out',
    '&.collapsed': {
      'width': theme.spacing(3),
      'marginRight': 16,
    },
  },
}));

export default function DeliveryStaffDetails({ id: inId, computedMatch, isNested }) {
  const { t } = useTranslation();
  const [id, setId] = useState();
  const [tabs, setTabs] = useState([]);
  const parentRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState('100%');
  const [isCardOpen, setIsCardOpen] = useState(true);
  const classes = useStyles();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const node = parentRef.current;
    if (!node) return;

    const updateWidth = () => {
      setContainerWidth(`${node.offsetWidth}px`);
    };

    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(node);
    updateWidth();

    const handleTransitionEnd = () => {
      window.dispatchEvent(new Event('calendar-should-resize'));
    };
    node.addEventListener('transitionend', handleTransitionEnd);

    return () => {
      resizeObserver.disconnect();
      node.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, [parentRef.current]);

  useEffect(() => {
    if (inId) {
      setId(inId);
    } else
    if (computedMatch) {
      const { params: { id } } = computedMatch;
      setId(id);
    }
  }, [inId, computedMatch]);

  useEffect(() => {
    if (!id) return;

    const tabs = [
      // {
      //   label: '基本資料',
      //   component: <DeliveryStaffCard title="基本資料" id={id} hideExpand={true} showMap={true} />,
      // },
      {
        label: '資料檔案',
        component: <DeliveryStaffDocumentTable nested={true} deliveryStaffId={id} padding={0}/>,
      },
      // {
      //   label: t('送餐紀錄'),
      //   component: <DeliveryStaffOrderTable nested={true} deliveryStaffId={id} padding={0} />,
      // },
      {
        label: '行事曆',
        component: <Schedule
          deliveryStaffId={id}
          showElderSelector={false}
          showLocationSelector={false}
          showDeliverStaffSelector={false}
          showRestaurantSelector={false}
          defaultLocations={[]}
          defaultOrderStatus={[
            'ready',
            'readyForPickup',
            'delivering',
            'delivered',
            'completed',
            'cancelled',
          ]} />,
      },
      {
        label: '訂單紀錄',
        component: <OrderTable nested={true} deliveryStaffId={id} padding={0} />,
      },
      {
        label: '週期性排單',
        component: <RecurringOrderTable nested={true} deliveryStaffId={id} padding={0} />,
      },
      {
        label: t('送餐關懷'),
        component: <DeliveryDiary deliveryStaffId={id} />,
      },
      // {
      //   label: '通知紀錄',
      //   component: <NotificationTable nested={true} deliveryStaffId={id} padding={0} />,
      // },
      // {
      //   label: '交易紀錄',
      //   component: <DeliveryStaffTransactionTable nested={true} deliveryStaffId={id} padding={0} />,
      // },
      // {
      //   label: '結算紀錄',
      //   component: <DeliveryStaffStatementTable nested={true} deliveryStaffId={id} padding={0} />,
      // },
      {
        label: '合約專區',
        component: <DeliveryStaffContract deliveryStaffId={id} />,
      },
    ];
    setTabs(tabs);
  }, [id]);

  if (!id) {
    return null;
  }

  return (
    <div ref={parentRef} style={{ width: '100%' }}>
      <Container maxWidth={false} style={{ width: containerWidth }}>
        <Grid container spacing={2} wrap="nowrap" justifyContent='flex-start'>
          <Grid item sm={12} md={isCardOpen ? 2 : 'auto'} lg={isCardOpen ? 2 : 'auto'} xl={isCardOpen ? 3 : 'auto'}
            className={`${classes.collapsibleGrid} ${!isCardOpen ? 'collapsed' : ''}`}>
            <DeliveryStaffCard
              title="基本資料"
              id={id}
              hideExpand={true}
              showMap={true}
              collapseDirection={isSm ? 'up' : 'left'}
              collapse={!isCardOpen}
              onCollapseChange={setIsCardOpen}
            />
          </Grid>
          <Grid item sm={12} md={isCardOpen ? 10 : 11} lg={isCardOpen ? 10 : 11} xl={isCardOpen ? 9 : 11}>
            <VerticalTabs
              tabs={tabs}
              padding={0}
              isNested={isNested}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

DeliveryStaffDetails.propTypes = {
  id: PropTypes.string,
  computedMatch: PropTypes.object,
  isNested: PropTypes.bool,
};
